// test2569
(2569 && 0);
